module.exports = __webpack_public_path__ + "img/the-field-gal-3.dbdccc53.jpg";